<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <!-- 病例类型 -->
    <div class="case-type">
      病历类型：
      <el-button size="small"
                 :style="activeName ==1 ? activeStyle : ''"
                 :disabled="module_id_array[0]?!module_id_array.includes('47'):false"
                 @click="changeType(1)">线上病历</el-button>
      <el-button size="small"
                 :style="activeName ==2 ? activeStyle : ''"
                 :disabled="module_id_array[0]?!module_id_array.includes('1100'):false"
                 @click="changeType(2)">实体医疗机构病例</el-button>
    </div>
    <div class="container">
      <template v-if="activeName == 1">
        <div style="border: solid 1px #c9cbd6;">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%;min-width:1000px;"
                    :header-cell-style="{background:'#F5F5F5'}">
            <el-table-column label="开方时间"
                             prop="create_time"></el-table-column>
            <el-table-column label="主述"
                             prop="chief_complaint"></el-table-column>
            <el-table-column label="诊断"
                             prop="diagnosis"></el-table-column>
            <el-table-column label="科室"
                             prop="department_name"></el-table-column>
            <el-table-column prop="doctor_name"
                             label="医生姓名">
              <template slot-scope="scope">
                <span @click="showDocMsg(scope.row.doctor_id)"
                      style="cursor:pointer">{{scope.row.doctor_name}}</span>
              </template>
            </el-table-column>
            <el-table-column label="职称"
                             prop="title"></el-table-column>
            <el-table-column label="手机号"
                             prop="phone"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text"
                           @click="toDetail(scope.row.pre_id)">查看病历</el-button>
                <!-- :disabled="module_id_array[0]?!module_id_array.includes('106'):false" -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination v-show="totalNum > 0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getList" />
      </template>

      <template v-else>
        <div class="timeline-box">
          <el-timeline>
            <el-timeline-item v-for="(item,index) in timelineList"
                              :key="index"
                              :timestamp="`${item.create_time} 上传`"
                              placement="top">
              <el-card>
                <el-image v-for="(kitem,kindex) in item.history_img"
                          :key="kindex"
                          style="width: 100px; height: 100px;margin-rigth:4px"
                          :src="item.history_img[kindex]"
                          :preview-src-list="item.history_img">
                </el-image>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </template>
    </div>

  </div>
</template>
<script>
import platform from '../../../api/platform';
import yewu from '../../../api/yewu';
import DocMsg from '../../../components/common/DocMsg.vue';
import dayjs from 'dayjs';
import Pagination from '@/components/Pagination/index';
export default {
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      tableData: [],
      doc_msg: false,
      doctorId: '',
      activeName: 1,
      activeStyle: {
        color: '#669961',
        borderColor: '#669961'
      },
      timelineList: []
    };
  },
  components: {
    DocMsg,
    Pagination
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        patient_id: this.$route.query.patient_id,
        user_id: this.$route.query.user_id
      };
      data = Object.assign({}, data, this.pagination);
      yewu.casehistoryList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = platform.timestampToTime(item.create_time);
            this.totalNum = res.data.total;
            return item;
          });
        }
      });
    },

    //详情
    toDetail(pre_id) {
      this.$router.push({
        path: 'binglidetail',
        query: {
          pre_id
        }
      });
    },
    changeType(activeName) {
      this.activeName = activeName;
      if (activeName == 2) {
        let params = {
          patient_id: this.$route.query.patient_id
        };
        yewu.patienthistorylist(params).then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.timelineList = data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format('YYYY-MM-DD');
              return item;
            });
            console.log(this.timelineList);
          }
        });
      } else {
        this.getList();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff;
  min-height: calc(100vh - 255px);
}
.searchbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.case-type {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-left: 20px;
}
.timeline-box {
  width: 46%;
  .el-timeline-item {
    ::v-deep .el-timeline-item__timestamp {
      text-align: left;
    }
    ::v-deep .el-card__body {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .el-image {
        margin-right: 4px;
        margin-bottom: 4px;
      }
    }
  }
}
</style>